import styled from 'styled-components';
import OrangeIcon from '../../assests/images/orangeicon.svg';

export const TopViewNominate = styled.div`
    
    @media screen and (max-width:1024px) {  
        padding-top: 128px;
    }
    @media screen and (max-width:991px) {  
        padding: 114px 0px 0px;
    }

    .nominate-banner-sec{     
        padding: 50px 0px;
            .search-header{
              @media screen and (max-width:480px) {
       justify-content: flex-end;
        padding: 9px !important;
      }
                .input-group {
       @media screen and (max-width:480px) {
          width: 100%;
}
            }
    }
`;

export const NonprofitsDonations = styled.div` 
    background: #F1FEFF;
    padding:52px 0;

    @media screen and (max-width:767px){
        padding-top: 40px;
    }
`;  
export const NonprofitsWrapper = styled.div`
    display: flex;
    gap:38px;

    @media screen and (max-width:575px) {  
        flex-wrap: wrap;
        gap:25px;
    }
`;
export const NonprofitsRight = styled.div`
    width:100%;
    max-width:816px;
`;
export const NonprofitsTitle = styled.h2`
    color: #333333;;
    font-family: "Jost", sans-serif;
    font-size:30px;
    line-height: 43px;
    font-weight: 700;
    margin-bottom: 20px;

    @media screen and (max-width:991px) {
        font-size:25px;
        line-height: 30px;
    }
`;

export const NonprofitsLeft = styled.div`
    width:100%;
    max-width:267px;

    @media screen and (max-width: 575px){
        margin: 0 auto;
    }
    img{
        width:100%;
    }
`;

export const TextCol = styled.div`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:18px;
    font-weight: 400;
    line-height: 27px;
    margin-bottom: 20px;
    &:last-child{
        margin-bottom: 0px;
    }
    @media screen and (max-width:575px) { 
        font-size:16px;
        line-height:25px;
    }
`;

export const NonprofitList = styled.ul`
    padding: 20px;
    margin: 45px 0 0 0;
    list-style: none;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 20px 20px #0000001A;
    border-radius: 20px;
    position: relative;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 20px 62px;

    @media screen and (max-width:1200px){
        gap: 20px 40px;
    }

    @media screen and (max-width:991px) {
        gap:20px;
    }
    @media screen and (max-width:575px) {
        padding: 10px;
    }
    &:after {
        background: rgb(51 167 174 / 50%);
        width: 1px;
        height: 84%;
        content: "";
        top: 18px;
        left: 48%;
        position: absolute; 
        @media screen and (max-width:1200px) { 
            left: 49%;
        }
        @media screen and (max-width:991px) {
            left: 50%;
            display:none;
        }
    }
    
    @media screen and (max-width:1200px) { 
        column-gap: 20px;
    }

    @media screen and (max-width:991px) { 
        flex-wrap: wrap;
        margin: 30px 0 0 0;
    }
`;
export const NonproFitText = styled.p`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:18px;
    font-weight: 400;
    line-height:27px;
    margin-bottom: 0px;

    @media screen and (max-width:575px) { 
        font-size:16px;
        line-height:25px;
    } 
`;
export const NonprofitsItem = styled.li`
    display: flex;
    gap: 10px;
    width: calc(50% - 62px);
    position: relative;
    padding-left: 30px;

    @media screen and (max-width:1200px){
        width: calc(50% - 15px);
    }
    @media screen and (max-width:575px){
        padding-left: 25px;
    }

    &::before{
        content: '';
        position: absolute;
        background-image: url(${OrangeIcon});
        background-repeat:  no-repeat;
        background-position: left top;
        background-size: contain;
        width: 20px;
        height: 20px;
        left:0;
        top: 2px;

        @media screen and (max-width: 991px){
            top: 3px;
        }

        @media screen and (max-width: 480px){
            width: 16px;
            height: 16px;
            top: 5px;
        }
    }

    @media screen and (max-width:991px) {
        width: 100%;
    }

    &:last-child{
        ${NonproFitText}{
            margin-bottom: 0px;
        }   
    }
`;


export const WriteReviewBottomForm = styled.div`
    background: transparent linear-gradient(292deg, #F7931E 0%, #33A7AE 100%) 0% 0% no-repeat padding-box;
    box-shadow: 0px 10px 30px #00000014;
    border-radius: 0px;
    padding: 30px 0 48px;

    @media screen and (max-width: 767px){
        padding: 30px 0px;
    }

    form .btn-outline-success-blue.form-btn{
        padding: 12px 65px;
    }

    .latest-news-in-container{
        background: transparent;
        box-shadow: none;
        border-radius: 0;
        padding: 0;
        margin-top: 0px;

        h3{
            font-size: 30px;;
            line-height: 44px;

            @media screen and (max-width: 575px){
                font-size: 24px;;
                line-height: 38px;
            }
        }

        .form-flex {    
            display: flex;
            align-items: flex-start;
            width: 100%;
            column-gap: 24px;

            @media screen and (max-width: 767px){
                flex-direction: column;
                row-gap: 20px;
            }

            .form-input-group{
                width: 100%;
            }
        }
        .input-group-checkbox{
            margin-bottom: 0px;
            column-gap: 40px;

            @media screen and (max-width: 480px){
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: flex-start;
            }
        }
    }

    form{
        .input-group {
            column-gap: 24px;

            .input-form-group {
                .form-control{
                    padding: 10px 20px;
                }
            }
        }
    }
    .form-check-input{
        &:focus{
            box-shadow: none;
        }
    }
`;

export const PageTopBanner = styled.div`
    .banner-image{
        border-radius: 10px;
    }
`;